export * from './skyscanner-widget-directive.model';
export * from './skyscanner-widget-directive.module';
